import React, { useEffect } from "react";
import { markEegStartup } from "../utils/eegStartupTelemetry";
import "../pages/EEGViewerPage.css";

type EEGPlayableShellProps = {
  label?: string;
  /** Optional status line under the brand (e.g. resolving recording). */
  detail?: React.ReactNode;
};

/**
 * Minimal first-paint shell for the direct EEG route. Keeps FCP off the
 * monolithic viewer chunk while manifest/readiness work proceeds.
 *
 * Sprint 4B: deliberately avoid becoming the LCP candidate — brand text is
 * visually small and marked as a non-LCP shell so the waveform canvas can
 * own the usable-viewer LCP once EEGPlaybackCore mounts.
 *
 * Used for both local Vite and portal production so cold open always shows
 * the same NerveDX EEG + progress-bar startup surface.
 */
const EEGPlayableShell: React.FC<EEGPlayableShellProps> = ({
  label = "NerveDX EEG",
  detail,
}) => {
  useEffect(() => {
    markEegStartup("routeShellPainted");
  }, []);

  return (
    <div
      className="eeg-viewer-loading eeg-viewer-startup-shell"
      role="status"
      data-eeg-playable-shell="true"
      data-eeg-lcp-suppress="true"
    >
      <div className="eeg-viewer-startup-shell__brand" aria-live="polite">
        {label}
      </div>
      <div className="eeg-viewer-startup-shell__bar" aria-hidden="true" />
      {detail ? (
        <div className="eeg-viewer-startup-shell__detail">{detail}</div>
      ) : null}
    </div>
  );
};

export default EEGPlayableShell;
